/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassstudentClassstudentidChannels200,
  GetApiV1ClassstudentClassstudentidChannels400,
  GetApiV1ClassstudentClassstudentidChannels401,
  GetApiV1ClassstudentClassstudentidChannels404,
  GetApiV1ClassstudentClassstudentidChannels500,
  GetApiV1ClassstudentClassstudentidChannelsPathParams,
  GetApiV1ClassstudentClassstudentidChannelsQueryParams,
  GetApiV1ClassstudentClassstudentidChannelsQueryResponse,
} from "../../types/classStudentChannelsController/GetApiV1ClassstudentClassstudentidChannels.ts";
import { channelListItemViewModelPaginatedResponseSchema } from "../channelListItemViewModelPaginatedResponseSchema.ts";

export const getApiV1ClassstudentClassstudentidChannelsPathParamsSchema =
  z.object({
    classStudentId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1ClassstudentClassstudentidChannelsPathParams>;

export const getApiV1ClassstudentClassstudentidChannelsQueryParamsSchema =
  z.object({
    Search: z.optional(
      z
        .string()
        .describe(
          "Texto livre aplicado ao nome do canal e ao ID do vídeo no Vimeo. Opcional.",
        ),
    ),
    Active: z
      .boolean()
      .default(true)
      .describe(
        "Filtra por situação do canal. Vem ligado por padrão, reproduzindo o filtro que no legado existia apenas no grid. Informe nulo para trazer ativos e inativos.",
      ),
    PageNumber: z.coerce
      .number()
      .int()
      .default(1)
      .describe("Página da listagem. Mínimo 1."),
    PageSize: z.coerce
      .number()
      .int()
      .default(30)
      .describe("Quantidade de itens por página. Entre 1 e 100."),
  }) as unknown as ToZod<GetApiV1ClassstudentClassstudentidChannelsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassstudentClassstudentidChannels200Schema = z.lazy(
  () => channelListItemViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1ClassstudentClassstudentidChannels200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1ClassstudentClassstudentidChannels400Schema =
  z.any() as unknown as ToZod<GetApiV1ClassstudentClassstudentidChannels400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassstudentClassstudentidChannels401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassstudentClassstudentidChannels401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassstudentClassstudentidChannels404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassstudentClassstudentidChannels404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ClassstudentClassstudentidChannels500Schema =
  z.any() as unknown as ToZod<GetApiV1ClassstudentClassstudentidChannels500>;

export const getApiV1ClassstudentClassstudentidChannelsQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassstudentClassstudentidChannels200Schema,
  ) as unknown as ToZod<GetApiV1ClassstudentClassstudentidChannelsQueryResponse>;
